import { render, staticRenderFns } from "./allBrandMarketSaleChangeTrend.vue?vue&type=template&id=45c8bfd4&scoped=true"
import script from "./allBrandMarketSaleChangeTrend.vue?vue&type=script&lang=js"
export * from "./allBrandMarketSaleChangeTrend.vue?vue&type=script&lang=js"
import style0 from "./allBrandMarketSaleChangeTrend.vue?vue&type=style&index=0&id=45c8bfd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c8bfd4",
  null
  
)

export default component.exports